import * as focusTrap from 'focus-trap'; // ESM

/* eslint-disable max-len, no-param-reassign */
const html = document.querySelector('html');
const lang = document.querySelector('html').getAttribute('lang');

// Traductions
const translations = {
    en: {
        removeFilter: 'Remove filter: ',
        resetFilters: 'Reset',
        applyFilters: 'Apply',
    },
    fr: {
        removeFilter: 'Retirer le filtre: ',
        resetFilters: 'Réinitialiser',
        applyFilters: 'Appliquer',
    },
};

function initMobilePanel(container) {
    const btnToggleEventPanel = container.querySelector('.event-filters-panel-toggle');
    const btnCloseEventPanel = container.querySelector('.event-filters-panel-close');
    const handleCloseEventPanel = container.querySelector('.event-filters-panel-handle');
    const eventFiltersPanel = container.querySelector('.event-filters-panel');

    const openEventFiltersPanel = () => {
        eventFiltersPanel.classList.add('opening-animation');

        btnToggleEventPanel.classList.add('is-open');
        window.calendarObj.updateSize();
        window.panelCalendarObj.updateSize();
        eventFiltersPanel.addEventListener(
            'animationend',
            () => {
                eventFiltersPanel.classList.remove('opening-animation');
                eventFiltersPanel.classList.add('is-open');
                html.classList.add('event-filters-panel-open');

                window.panelFocusTrap = focusTrap.createFocusTrap(eventFiltersPanel, {
                    escapeDeactivates: false,
                    allowOutsideClick: true,
                });
                window.panelFocusTrap.activate();
            },
            { once: true },
        );
    };
    const closeEventFiltersPanel = () => {
        eventFiltersPanel.classList.add('closing-animation');
        eventFiltersPanel.addEventListener(
            'animationend',
            () => {
                eventFiltersPanel.classList.remove('closing-animation');
                btnToggleEventPanel.classList.remove('is-open');
                eventFiltersPanel.classList.remove('is-open');
                html.classList.remove('event-filters-panel-open');
                window.calendarObj.updateSize();
                window.panelCalendarObj.updateSize();
                window.panelFocusTrap.deactivate();
            },
            { once: true },
        );
    };
    btnToggleEventPanel.addEventListener('click', (e) => {
        if (html.classList.contains('event-filters-panel-open')) {
            closeEventFiltersPanel();
        } else {
            openEventFiltersPanel(e);
        }
    });
    btnCloseEventPanel.addEventListener('click', () => {
        closeEventFiltersPanel();
    });
    handleCloseEventPanel.addEventListener('click', () => {
        closeEventFiltersPanel();
    });
}

function createTag(optionValue, optionText, selectName) {
    const li = document.createElement('li');
    li.className = 'event-filters-tag';
    li.dataset.value = optionValue;

    const span = document.createElement('span');
    span.className = 'event-filters-tag-label';
    span.textContent = optionText;

    const button = document.createElement('button');
    button.className = 'event-filters-tag-delete';
    button.type = 'button';
    button.innerHTML = `<span aria-hidden="true">✕</span><span class="visually-hidden">${translations[lang].removeFilter} ${optionText}</span>`;
    button.addEventListener('click', (ev) => {
        const currentTag = ev.currentTarget.closest('.event-filters-tag');
        const container = currentTag.closest('.event-filters-container');
        const select = container.querySelector(`select[name="${selectName}"]`);
        select.querySelector(`option[value="${currentTag.dataset.value}"]`).selected = false;
        const checkbox = container.querySelector(`.event-facet-list-item-checkbox[name="${selectName}"][value="${currentTag.dataset.value}"]`);
        checkbox.checked = false;
        container.querySelector('.js-form-submit').click();
        currentTag.remove();
    });

    li.appendChild(span);
    li.appendChild(button);

    return li;
}

function createDateTag(dateStart, dateEnd) {
    const li = document.createElement('li');
    li.className = 'event-filters-tag';

    const span = document.createElement('span');
    span.className = 'event-filters-tag-label';

    // Convert date strings to Date objects
    const startDate = new Date(dateStart);
    const endDate = new Date(dateEnd);
    // Le range est exclusif alors on veut la vraie date de fin
    endDate.setDate(endDate.getDate() - 1);

    // Format dates based on the locale
    const locale = (lang === 'fr') ? 'fr-CA' : 'en-CA';
    const dateOptions = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        timeZone: 'UTC',
    };
    const startDateFormatted = new Intl.DateTimeFormat(locale, dateOptions).format(startDate);
    const endDateFormatted = new Intl.DateTimeFormat(locale, dateOptions).format(endDate);

    if (startDateFormatted === endDateFormatted) {
        span.textContent = `Date : ${startDateFormatted}`;
    } else {
        span.textContent = `Date(s) : ${startDateFormatted} - ${endDateFormatted}`;
    }

    const button = document.createElement('button');
    button.className = 'event-filters-tag-delete';
    button.type = 'button';
    button.innerHTML = `<span aria-hidden="true">✕</span><span class="visually-hidden">${translations[lang].removeFilter} date</span>`;
    button.addEventListener('click', (ev) => {
        const currentTag = ev.currentTarget.closest('.event-filters-tag');
        const container = currentTag.closest('.event-filters-container');

        document.querySelector('.js-form-item-event-date-min input').value = '';
        document.querySelector('.js-form-item-event-date-max input').value = '';

        container.querySelector('.js-form-submit').click();
        currentTag.remove();
    });

    li.appendChild(span);
    li.appendChild(button);

    return li;
}

// Ajoute le footer au panel mobile des filtres
function createMobilePanelFooter(container) {
    const panel = container.querySelector('.event-filters-panel');
    const tagContainer = container.querySelector('.event-filters-tags');
    const tagContainerMobile = container.querySelector('.event-filters-tags-mobile');

    // Footer with buttons
    const footer = document.createElement('div');
    footer.className = 'event-filters-panel-footer';

    const clearButton = document.createElement('button');
    clearButton.className = 'button clear js-clear-checkboxes';
    clearButton.textContent = `${translations[lang].resetFilters}`;
    clearButton.type = 'button';
    clearButton.addEventListener('click', () => {
        const checkboxes = panel.querySelectorAll('.event-facet-list-item-checkbox');
        checkboxes.forEach((checkbox) => {
            checkbox.checked = false;
        });
    });

    const applyButton = document.createElement('button');
    applyButton.className = 'button primary js-update-filter';
    applyButton.textContent = `${translations[lang].applyFilters}`;
    applyButton.type = 'button';
    applyButton.addEventListener('click', () => {
        // Update all select elements with the checked values
        const selects = container.querySelectorAll('select');
        selects.forEach((selectElement) => {
            const selectName = selectElement.name;
            const checkedValues = new Set(Array.from(panel.querySelectorAll(`input[name="${selectName}"][type="checkbox"]:checked`)).map((cb) => cb.value));
            selectElement.querySelectorAll('option').forEach((option) => {
                option.selected = checkedValues.has(option.value);
                if (option.selected && !tagContainer.querySelector(`[data-value="${option.value}"]`)) {
                    const tag = createTag(option.value, option.textContent, selectElement.name);
                    tagContainer.appendChild(tag);
                    const tagMobile = createTag(option.value, option.textContent, selectElement.name);
                    tagContainerMobile.appendChild(tagMobile);
                } else if (!option.selected) {
                    const existingTag = tagContainer.querySelector(`[data-value="${option.value}"]`);
                    if (existingTag) {
                        tagContainer.removeChild(existingTag);
                    }
                    const existingTagMobile = tagContainerMobile.querySelector(`[data-value="${option.value}"]`);
                    if (existingTagMobile) {
                        tagContainerMobile.removeChild(existingTagMobile);
                    }
                }
            });
        });
        container.querySelector('.js-form-submit').click();
    });

    footer.appendChild(clearButton);
    footer.appendChild(applyButton);
    panel.appendChild(footer);
}

function createEventFacetSelectors() {
    document.querySelectorAll('.event-filters-container').forEach((container) => {
        // Create the tag container
        const tagContainer = document.createElement('ul');
        tagContainer.className = 'event-filters-tags';
        container.insertBefore(tagContainer, container.querySelector('.event-filters-metadata-row'));

        // Create the tag container mobile
        const tagContainerMobile = document.createElement('ul');
        tagContainerMobile.className = 'event-filters-tags-mobile';
        container.querySelector('.panel-event-filters-tags').appendChild(tagContainerMobile);

        const formItems = container.querySelectorAll('.js-form-type-select');
        formItems.forEach((formItem) => {
            // Create the main div
            const facetSelector = document.createElement('div');
            facetSelector.classList.add('event-facet-selector');

            // Create the toggle button
            const toggleButton = document.createElement('button');
            toggleButton.className = 'event-facet-selector-toggle';
            toggleButton.textContent = formItem.querySelector('label').textContent;
            toggleButton.addEventListener('click', (ev) => {
                ev.preventDefault();
                const facetSelectorToggle = ev.target;
                const currentFacetSelector = facetSelectorToggle.closest('.event-facet-selector');
                const otherFacetSelectors = Array.from(document.querySelectorAll('.event-facet-selector.is-active'))
                    .filter((facet) => facet !== currentFacetSelector);

                if (currentFacetSelector.classList.contains('is-active')) {
                    currentFacetSelector.classList.remove('is-active');
                    facetSelectorToggle.setAttribute('aria-expanded', 'false');
                } else {
                    otherFacetSelectors.forEach((selector) => {
                        selector.classList.remove('is-active');
                        selector.querySelector('.event-facet-selector-toggle').setAttribute('aria-expanded', 'false');
                    });
                    currentFacetSelector.classList.add('is-active');
                    currentFacetSelector.setAttribute('aria-expanded', 'true');
                }
            });
            facetSelector.appendChild(toggleButton);

            // Create the panel that will hold the content
            const panel = document.createElement('div');
            panel.className = 'event-facet-selector-panel';

            // Create the content div
            const content = document.createElement('div');
            content.className = 'event-facet-selector-content';

            // Create the list
            const list = document.createElement('ul');
            list.className = 'event-facet-list';

            // Iterate over the select options to create list items
            const selectElement = formItem.querySelector('select');
            selectElement.querySelectorAll('option').forEach((option) => {
                if (option.value !== 'All') {
                    const listItem = document.createElement('li');
                    listItem.className = 'event-facet-list-item';

                    const label = document.createElement('label');
                    label.className = 'event-facet-list-item-label';

                    const checkbox = document.createElement('input');
                    checkbox.type = 'checkbox';
                    checkbox.className = 'event-facet-list-item-checkbox';
                    checkbox.value = option.value;
                    checkbox.name = selectElement.name;
                    checkbox.checked = option.selected;

                    const labelText = document.createElement('span');
                    labelText.className = 'event-facet-list-item-label-text';
                    labelText.textContent = option.textContent;

                    // Sync initial tags
                    if (option.selected) {
                        const existingTag = tagContainer.querySelector(`[data-value="${option.value}"]`);
                        if (!existingTag) {
                            const tag = createTag(option.value, option.textContent, selectElement.name);
                            tagContainer.appendChild(tag);
                            const tagMobile = createTag(option.value, option.textContent, selectElement.name);
                            tagContainerMobile.appendChild(tagMobile);
                        }
                    }
                    label.appendChild(checkbox);
                    label.appendChild(labelText);
                    listItem.appendChild(label);
                    list.appendChild(listItem);
                }
            });

            content.appendChild(list);
            panel.appendChild(content);

            // Footer with buttons
            const footer = document.createElement('div');
            footer.className = 'event-facet-selector-footer';

            const clearButton = document.createElement('button');
            clearButton.className = 'button clear js-clear-checkboxes';
            clearButton.textContent = `${translations[lang].resetFilters}`;
            clearButton.type = 'button';
            clearButton.addEventListener('click', () => {
                const checkboxes = panel.querySelectorAll('.event-facet-list-item-checkbox');
                checkboxes.forEach((checkbox) => {
                    checkbox.checked = false;
                });
            });

            const applyButton = document.createElement('button');
            applyButton.className = 'button primary js-update-filter';
            applyButton.textContent = `${translations[lang].applyFilters}`;
            applyButton.type = 'button';
            applyButton.addEventListener('click', () => {
                // Update the select element with the checked values
                const checkedValues = new Set(Array.from(list.querySelectorAll('input[type="checkbox"]:checked')).map((cb) => cb.value));
                selectElement.querySelectorAll('option').forEach((option) => {
                    option.selected = checkedValues.has(option.value);
                    if (option.selected && !tagContainer.querySelector(`[data-value="${option.value}"]`)) {
                        const tag = createTag(option.value, option.textContent, selectElement.name);
                        tagContainer.appendChild(tag);
                        const tagMobile = createTag(option.value, option.textContent, selectElement.name);
                        tagContainerMobile.appendChild(tagMobile);
                    } else if (!option.selected) {
                        const existingTag = tagContainer.querySelector(`[data-value="${option.value}"]`);
                        if (existingTag) {
                            tagContainer.removeChild(existingTag);
                        }
                        const existingTagMobile = tagContainer.querySelector(`[data-value="${option.value}"]`);
                        if (existingTagMobile) {
                            tagContainerMobile.removeChild(existingTagMobile);
                        }
                    }
                });
                container.querySelector('.js-form-submit').click();
            });

            footer.appendChild(clearButton);
            footer.appendChild(applyButton);
            panel.appendChild(footer);

            // Append the panel to the main div
            facetSelector.appendChild(panel);

            // Append the facetSelector to the container
            container.querySelector('.event-filters').appendChild(facetSelector);
        });

        if (container.querySelector('.js-form-item-event-date-min')) {
            const dateStart = document.querySelector('.js-form-item-event-date-min input').value || '';
            const dateEnd = document.querySelector('.js-form-item-event-date-max input').value || '';
            if (dateStart && dateEnd) {
                const dateTag = createDateTag(dateStart, dateEnd);
                tagContainer.prepend(dateTag);
                const dateTagMobile = createDateTag(dateStart, dateEnd);
                tagContainerMobile.prepend(dateTagMobile);
            }
        }
        createMobilePanelFooter(container);
        initMobilePanel(container);
    });
    document.addEventListener('click', (ev) => {
        const activeFacetSelectors = document.querySelectorAll('.event-facet-selector.is-active');
        activeFacetSelectors.forEach((selector) => {
            if (!selector.contains(ev.target)) {
                selector.classList.remove('is-active');
                selector.querySelector('.event-facet-selector-toggle').setAttribute('aria-expanded', 'false');
            }
        });
    });
    document.addEventListener('keydown', (ev) => {
        if (ev.key === 'Escape') {
            const activeFacetSelectors = document.querySelectorAll('.event-facet-selector.is-active');
            activeFacetSelectors.forEach((selector) => {
                selector.classList.remove('is-active');
                selector.querySelector('.event-facet-selector-toggle').setAttribute('aria-expanded', 'false');
            });
        }
    });
}

function setLegendVisibility(visible) {
    if (visible) {
        document.querySelector('.js-expandmore-button').setAttribute('aria-expanded', 'true');
        document.querySelector('.js-to_expand').dataset.hidden = '';
    } else {
        document.querySelector('.js-expandmore-button').setAttribute('aria-expanded', 'false');
        document.querySelector('.js-to_expand').dataset.hidden = 'true';
    }
}

// Observer pour regénérer les checkboxes quand on change de filtre
const observerConfig = {
    childList: true, // Observe direct children additions or removals
    attributes: true, // Observe attribute changes
    subtree: true, // Observe all descendants
    attributeOldValue: true, // Include the previous value of the attribute
};

const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'data-once') {
            if (mutation.oldValue === 'exposed-form form-updated') {
                document.querySelectorAll('.event-facet-selector').forEach((e) => e.parentNode.removeChild(e));
                createEventFacetSelectors();
            }
        }
    });
});

if (document.querySelector('.training-events-page-content')) {
    document.addEventListener('DOMContentLoaded', () => {
        window.panelFocusTrap = null;
        createEventFacetSelectors();

        const mediaQuery = window.matchMedia('(max-width: 767px)');
        if (mediaQuery.matches) {
            setLegendVisibility(false);
        } else {
            setLegendVisibility(true);
        }
        mediaQuery.addEventListener('change', () => {
            if (mediaQuery.matches) {
                setLegendVisibility(false);
            } else {
                setLegendVisibility(true);
            }
        });
    });
    [...document.querySelectorAll('.training-events-page-content .views-element-container')].forEach((item) => {
        observer.observe(item, observerConfig);
    });
}
